import { render, staticRenderFns } from "./_hosting-teaser.vue?vue&type=template&id=4ff6844e&scoped=true&"
import script from "./_hosting-teaser.vue?vue&type=script&lang=js&"
export * from "./_hosting-teaser.vue?vue&type=script&lang=js&"
import style0 from "./_hosting-teaser.vue?vue&type=style&index=0&id=4ff6844e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff6844e",
  null
  
)

export default component.exports